import { addDoc, collection, doc, updateDoc } from '@firebase/firestore';
import { db } from '../firebase/firebase-config';
import { Timestamp } from 'firebase/firestore';
import {
	getUserBasicInfo,
	handleError,
	handleSuccess,
	whichEnvURL,
} from '../helpers/utils';

// Create notification
export const createNotification = async (data) => {
	const dbRef = collection(
		db,
		whichEnvURL(true) === 'live' ? 'notifications' : 'notifications_stage'
	);

	try {
		return await addDoc(dbRef, {
			...data,
			created: Timestamp.fromDate(new Date()),
		});
	} catch (error) {
		handleError(error, 'Ocurrió un error al crear la notificación [x]');
	}
};

// Update notification
export const updateNotification = (id = null, isDone = false, user) => {
	if (!id) handleError(null, 'El id de la notificación no es válido');

	updateDoc(
		doc(
			db,
			whichEnvURL(true) === 'live'
				? 'notifications'
				: 'notifications_stage',
			id
		),
		{
			isDone: !isDone,
			solved_date: !isDone ? Timestamp.fromDate(new Date()) : null,
			updated: Timestamp.fromDate(new Date()),
			reviewed_by: getUserBasicInfo(user),
		}
	).then(() => {
		handleSuccess('Notificación actualizada');
	});
};
